import { Circle, G, Path, Svg } from "react-native-svg";

export const ArrowBack = () => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M9.04436 17.5756L9.32057 17.2994C9.50362 17.1163 9.50362 16.8195 9.32057 16.6365L2.34815 9.66404H17.0312C17.2901 9.66404 17.5 9.45416 17.5 9.19529V8.80467C17.5 8.5458 17.2901 8.33592 17.0312 8.33592H2.34815L9.32057 1.3635C9.50362 1.18045 9.50362 0.883652 9.32057 0.700566L9.04436 0.424395C8.86131 0.241348 8.56452 0.241348 8.38147 0.424395L0.137285 8.66854C-0.0457617 8.85158 -0.0457617 9.14838 0.137285 9.33146L8.38147 17.5756C8.56452 17.7587 8.86131 17.7587 9.04436 17.5756Z"
        fill="#1B4965"
      />
    </Svg>
  );
};
export const ArrowRight = () => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M8.95562 0.424432L8.67941 0.700605C8.49636 0.883651 8.49636 1.18045 8.67941 1.36353L15.6518 8.33596L0.968736 8.33596C0.709868 8.33596 0.499986 8.54584 0.499986 8.80471L0.499985 9.19533C0.499985 9.4542 0.709868 9.66408 0.968735 9.66408L15.6518 9.66408L8.67941 16.6365C8.49636 16.8195 8.49636 17.1163 8.67941 17.2994L8.95562 17.5756C9.13866 17.7587 9.43546 17.7587 9.61851 17.5756L17.8627 9.33146C18.0457 9.14842 18.0457 8.85162 17.8627 8.66854L9.61851 0.424394C9.43546 0.241346 9.13866 0.241347 8.95562 0.424432Z"
        fill="#1B4965"
      />
    </Svg>
  );
};

export const PlayIcon = ({ color }) => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M20.3938 10.064L3.89375 0.309337C2.55313 -0.48285 0.5 0.2859 0.5 2.24528V21.75C0.5 23.5078 2.40781 24.5672 3.89375 23.6859L20.3938 13.9359C21.8656 13.0687 21.8703 10.9312 20.3938 10.064Z"
        fill={color || "white"}
      />
    </Svg>
  );
};
export const LikeIcon = ({ color }) => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M23.2808 13.3914C23.7461 12.7879 24 12 24 11.0376C24 9.27159 22.4966 7.6358 20.5909 7.6358H17.3026C17.7114 6.82167 18.2727 5.81184 18.2727 4.36312C18.2728 1.62525 17.1805 0 14.3864 0C12.9804 0 12.4586 1.77741 12.1913 3.15131C12.0316 3.97214 11.8807 4.7475 11.4167 5.21152C10.3118 6.31641 8.625 9 7.61166 9.54492C7.50905 9.58814 7.37794 9.62217 7.23516 9.64913C6.96455 9.25706 6.51239 9 6 9H1.5C0.671578 9 0 9.67158 0 10.5V22.5C0 23.3284 0.671578 24 1.5 24H6C6.82842 24 7.5 23.3284 7.5 22.5V22.0903C9.0232 22.0903 12.2197 24.0003 15.8182 23.9993C16.0763 23.9995 17.583 24.0007 17.7407 23.9993C20.5195 24 22.0651 22.3171 21.9751 19.7903C22.6842 18.9593 23.0317 17.7589 22.8294 16.6448C23.4133 15.7295 23.5385 14.4383 23.2808 13.3914ZM1.5 22.5V10.5H6V22.5H1.5ZM21.3758 12.954C22.125 13.5 22.125 15.75 21.113 16.2664C21.7468 17.3333 21.1763 18.7609 20.4091 19.1725C20.7979 21.6353 19.5203 22.4821 17.7273 22.4994C17.5721 22.5008 15.9814 22.4994 15.8182 22.4994C12.3997 22.4994 9.50222 20.5903 7.50005 20.5903V11.0449C9.26761 11.0449 10.8893 7.86028 12.4774 6.2722C13.9092 4.84041 13.4319 2.45405 14.3865 1.49953C16.7728 1.49953 16.7728 3.16439 16.7728 4.36317C16.7728 6.34078 15.341 7.22677 15.341 9.13584H20.591C21.6564 9.13584 22.4954 10.0904 22.5 11.0449C22.5047 11.9994 22.125 12.75 21.3758 12.954ZM4.875 20.25C4.875 20.8713 4.37133 21.375 3.75 21.375C3.12867 21.375 2.625 20.8713 2.625 20.25C2.625 19.6287 3.12867 19.125 3.75 19.125C4.37133 19.125 4.875 19.6287 4.875 20.25Z"
        fill={color || "#D4CBCA"}
      />
    </Svg>
  );
};
export const FavoriteIcon = ({ color }) => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M21.6703 1.93908C19.1156 -0.235919 15.2953 0.125019 12.9234 2.57189L12 3.52814L11.0766 2.57658C9.16407 0.598457 5.30625 -0.592169 2.32969 1.93908C-0.61406 4.45158 -0.768747 8.96096 1.86563 11.6797L10.9359 21.0453C11.2266 21.3453 11.6109 21.5 11.9953 21.5C12.3797 21.5 12.7641 21.35 13.0547 21.0453L22.125 11.6797C24.7688 8.96096 24.6141 4.45158 21.6703 1.93908ZM21.0563 10.6391L12.0188 20.0047L2.94375 10.6391C1.14375 8.78283 0.768753 5.24377 3.30469 3.08283C5.87344 0.889081 8.89219 2.47814 9.99844 3.62189L12 5.68908L14.0016 3.62189C15.0891 2.49689 18.1359 0.903144 20.6953 3.08283C23.2266 5.23908 22.8563 8.77815 21.0563 10.6391Z"
        fill={color || "#D4CBCA"}
      />
    </Svg>
  );
};

export const SearchIcon = () => {
  <Svg
    width="100%"
    height="100%"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8645 11.3208H12.0515L11.7633 11.0429C12.7719 9.86964 13.3791 8.34648 13.3791 6.68954C13.3791 2.99485 10.3842 0 6.68954 0C2.99485 0 0 2.99485 0 6.68954C0 10.3842 2.99485 13.3791 6.68954 13.3791C8.34648 13.3791 9.86964 12.7719 11.0429 11.7633L11.3208 12.0515V12.8645L16.4666 18L18 16.4666L12.8645 11.3208ZM6.68954 11.3208C4.12693 11.3208 2.05832 9.25214 2.05832 6.68954C2.05832 4.12693 4.12693 2.05832 6.68954 2.05832C9.25214 2.05832 11.3208 4.12693 11.3208 6.68954C11.3208 9.25214 9.25214 11.3208 6.68954 11.3208Z"
      fill="#1B4965"
    />
  </Svg>;
};

export const Avatar = ({ color }) => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M12.25 11.25C11.1289 11.25 10.5898 11.875 8.75 11.875C6.91016 11.875 6.375 11.25 5.25 11.25C2.35156 11.25 0 13.6016 0 16.5V18.125C0 19.1602 0.839844 20 1.875 20H15.625C16.6602 20 17.5 19.1602 17.5 18.125V16.5C17.5 13.6016 15.1484 11.25 12.25 11.25ZM16.25 18.125C16.25 18.4688 15.9688 18.75 15.625 18.75H1.875C1.53125 18.75 1.25 18.4688 1.25 18.125V16.5C1.25 14.293 3.04297 12.5 5.25 12.5C6.01562 12.5 6.77734 13.125 8.75 13.125C10.7188 13.125 11.4844 12.5 12.25 12.5C14.457 12.5 16.25 14.293 16.25 16.5V18.125ZM8.75 10C11.5117 10 13.75 7.76172 13.75 5C13.75 2.23828 11.5117 0 8.75 0C5.98828 0 3.75 2.23828 3.75 5C3.75 7.76172 5.98828 10 8.75 10ZM8.75 1.25C10.8164 1.25 12.5 2.93359 12.5 5C12.5 7.06641 10.8164 8.75 8.75 8.75C6.68359 8.75 5 7.06641 5 5C5 2.93359 6.68359 1.25 8.75 1.25Z"
        fill={color || "#1B4965"}
      />
    </Svg>
  );
};

export const ScoreBook = () => {
  return (
    <Svg
      width="23"
      height="26"
      viewBox="0 0 23 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M18.2768 8.125H9.65179C9.31295 8.125 9.03571 7.85078 9.03571 7.51562V7.10938C9.03571 6.77422 9.31295 6.5 9.65179 6.5H18.2768C18.6156 6.5 18.8929 6.77422 18.8929 7.10938V7.51562C18.8929 7.85078 18.6156 8.125 18.2768 8.125ZM18.8929 10.7656V10.3594C18.8929 10.0242 18.6156 9.75 18.2768 9.75H9.65179C9.31295 9.75 9.03571 10.0242 9.03571 10.3594V10.7656C9.03571 11.1008 9.31295 11.375 9.65179 11.375H18.2768C18.6156 11.375 18.8929 11.1008 18.8929 10.7656ZM22.2145 24.375H22.3839C22.7228 24.375 23 24.6492 23 24.9844V25.3906C23 25.7258 22.7228 26 22.3839 26H4.10714C1.83795 26 0 24.182 0 21.9375V4.0625C0 1.81797 1.83795 0 4.10714 0H21.7679C22.4507 0 23 0.543359 23 1.21875V19.9062C23 20.4141 22.6817 20.8508 22.235 21.0336C22.0502 21.8512 22.0092 23.3492 22.2145 24.375ZM6.57143 19.5H21.3571V1.625H6.57143V19.5ZM1.64286 20.3125C2.3308 19.8047 3.18304 19.5 4.10714 19.5H4.92857V1.625H4.10714C2.74665 1.625 1.64286 2.7168 1.64286 4.0625V20.3125ZM20.7565 24.375C20.5973 23.3391 20.6076 22.0797 20.7565 21.125H4.10714C0.821429 21.125 0.821429 24.375 4.10714 24.375H20.7565Z"
        fill="#A8C492"
      />
    </Svg>
  );
};
export const ScoreHand = () => {
  return (
    <Svg
      width="23"
      height="26"
      viewBox="0 0 24 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M20.9999 5.90625C20.5392 5.90625 20.1053 6.00645 19.7142 6.19102V4.64062C19.7142 3.01113 18.3696 1.6875 16.7142 1.6875C16.1946 1.6875 15.7071 1.81934 15.2839 2.04609C14.8928 0.85957 13.7624 0 12.4285 0C11.0946 0 9.96422 0.85957 9.57315 2.04609C9.14994 1.81934 8.66244 1.6875 8.14279 1.6875C6.48744 1.6875 5.14279 3.01113 5.14279 4.64062V12.6984C4.52672 12.0762 2.88744 11.2377 1.28029 12.3451C-0.0750641 13.2785 -0.407207 15.1242 0.541007 16.4584L6.63208 25.4918C7.26958 26.4357 8.33565 27 9.48744 27H19.1624C20.791 27 22.2053 25.8609 22.5267 24.2895L23.6303 18.8473C23.8714 17.6502 23.9946 16.4268 23.9946 15.2086V8.85938C23.9999 7.22988 22.6553 5.90625 20.9999 5.90625ZM22.2857 15.2033C22.2857 16.316 22.1731 17.4234 21.9535 18.515L20.8499 23.9572C20.6892 24.7482 19.9874 25.3125 19.1678 25.3125H9.49279C8.91958 25.3125 8.38386 25.0277 8.06244 24.5584L1.94458 15.4934C1.53744 14.9186 1.67672 14.1328 2.26065 13.732C3.10708 13.1467 3.86779 13.7848 4.04994 14.0432L6.07494 16.9119C6.31601 17.2494 6.85708 17.0859 6.85708 16.6693V4.64062C6.85708 3.93926 7.43029 3.375 8.14279 3.375C8.85529 3.375 9.42851 3.93926 9.42851 4.64062V13.0781C9.42851 13.3102 9.62136 13.5 9.85708 13.5H10.7142C10.9499 13.5 11.1428 13.3102 11.1428 13.0781V2.95312C11.1428 2.25176 11.716 1.6875 12.4285 1.6875C13.141 1.6875 13.7142 2.25176 13.7142 2.95312V13.0781C13.7142 13.3102 13.9071 13.5 14.1428 13.5H14.9999C15.2357 13.5 15.4285 13.3102 15.4285 13.0781V4.64062C15.4285 3.93926 16.0017 3.375 16.7142 3.375C17.4267 3.375 17.9999 3.93926 17.9999 4.64062V13.0781C17.9999 13.3102 18.1928 13.5 18.4285 13.5H19.2857C19.5214 13.5 19.7142 13.3102 19.7142 13.0781V8.85938C19.7142 8.15801 20.2874 7.59375 20.9999 7.59375C21.7124 7.59375 22.2857 8.15801 22.2857 8.85938V15.2033ZM17.8553 15.7676C17.5285 15.5092 16.966 15.1875 16.2321 15.1875C15.5303 15.1875 14.6678 15.4828 13.7142 16.4057C12.7606 15.4828 11.8982 15.1875 11.1964 15.1875C10.4624 15.1875 9.89458 15.5092 9.57315 15.7676C8.30886 16.7748 8.24458 18.5889 9.37494 19.6805L13.2642 23.4404C13.516 23.683 13.9232 23.683 14.1749 23.4404L18.0642 19.6805C19.1839 18.5889 19.1196 16.7748 17.8553 15.7676ZM16.8535 18.4781L13.7142 21.5156L10.5749 18.4781C9.93208 17.8559 10.4624 16.875 11.1964 16.875C11.5553 16.875 12.0267 17.1387 12.5142 17.608L13.7142 18.7734L14.9142 17.608C15.4017 17.1334 15.8731 16.875 16.2321 16.875C16.966 16.875 17.4964 17.8559 16.8535 18.4781Z"
        fill="#A8C492"
      />
    </Svg>
  );
};
export const ScoreShake = () => {
  return (
    <Svg
      width="33"
      height="26"
      viewBox="0 0 33 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M32.9432 10.6492L32.5307 9.94333C32.4172 9.75036 32.1646 9.68434 31.9687 9.79606L26.3999 12.9953V12.1879C26.3999 10.8422 25.2913 9.75036 23.9249 9.75036H16.4999V12.909C16.4999 13.7215 15.9379 14.473 15.1283 14.6C14.0971 14.7675 13.1999 13.9804 13.1999 12.9953V8.20661C13.1999 7.50583 13.566 6.85583 14.1693 6.48512L15.8915 5.42379C16.4793 5.06325 17.1599 4.87028 17.856 4.87028H23.1772L29.2874 1.46793C29.4833 1.35622 29.5555 1.10739 29.4421 0.914419L29.0296 0.203482C28.9162 0.0105129 28.6635 -0.0605809 28.4676 0.0511379L22.7441 3.25036H17.8612C16.8557 3.25036 15.8708 3.52965 15.0201 4.0527L13.2927 5.11403C12.3904 5.67262 11.8129 6.56637 11.6324 7.57692L8.40975 9.45583C7.296 10.116 6.5999 11.3195 6.5999 12.5992V14.5593L0.206154 18.1343C0.0102164 18.2461 -0.0619711 18.4949 0.0514664 18.6879L0.463966 19.3937C0.577404 19.5867 0.83006 19.6578 1.026 19.5461L8.2499 15.5039V12.5992C8.2499 11.8882 8.63662 11.2179 9.25022 10.8523L11.5499 9.51169V12.8582C11.5499 14.5543 12.8029 16.0726 14.5199 16.2351C16.4844 16.423 18.1499 14.8996 18.1499 13.0004V11.3754H23.9249C24.3787 11.3754 24.7499 11.741 24.7499 12.1879V13.8129C24.7499 14.2597 24.3787 14.6254 23.9249 14.6254H22.6874V16.4535C22.6874 17.459 21.8624 18.2715 20.8415 18.2715H20.0113V19.084C20.0113 20.2113 19.0832 21.1254 17.9385 21.1254H12.2976L6.33694 24.5429C6.141 24.6547 6.07397 24.9035 6.1874 25.0965L6.5999 25.7972C6.71334 25.9902 6.966 26.0562 7.16193 25.9445L12.741 22.7504H17.9385C19.7329 22.7504 21.2385 21.491 21.5891 19.8203C23.1566 19.48 24.3374 18.0988 24.3374 16.4535V16.2148C25.0387 16.098 25.6058 15.6765 25.9771 15.1129L32.7937 11.2027C32.9896 11.091 33.0566 10.8422 32.9432 10.6492Z"
        fill="#A8C492"
      />
    </Svg>
  );
};
export const ScoreGift = () => {
  return (
    <Svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M25.375 7.875H23.2258C23.7453 7.14219 24.0625 6.23984 24.0625 5.25C24.0625 2.83828 22.2359 0.875 19.9883 0.875C17.675 0.875 16.3352 2.26406 14 6.11406C11.6648 2.26406 10.325 0.875 8.01172 0.875C5.76406 0.875 3.9375 2.83828 3.9375 5.25C3.9375 6.23984 4.25469 7.14219 4.77422 7.875H2.625C1.17578 7.875 0 9.05078 0 10.5V15.75C0 16.2312 0.39375 16.625 0.875 16.625H1.75V24.5C1.75 25.9492 2.92578 27.125 4.375 27.125H23.625C25.0742 27.125 26.25 25.9492 26.25 24.5V16.625H27.125C27.6063 16.625 28 16.2312 28 15.75V10.5C28 9.05078 26.8242 7.875 25.375 7.875ZM15.1047 7.67812C17.8117 3.12266 18.7141 2.625 19.9883 2.625C21.268 2.625 22.3125 3.80078 22.3125 5.25C22.3125 6.69922 21.268 7.875 19.9883 7.875H14.9844L15.1047 7.67812ZM8.01172 2.625C9.29141 2.625 10.1883 3.12266 12.8953 7.67812L13.0102 7.875H8.00625C6.72656 7.875 5.68203 6.69922 5.68203 5.25C5.6875 3.80078 6.73203 2.625 8.01172 2.625ZM10.5 25.375H4.375C3.89375 25.375 3.5 24.9813 3.5 24.5V16.625H10.5V25.375ZM10.5 14.875H1.75V10.5C1.75 10.0188 2.14375 9.625 2.625 9.625H10.5V14.875ZM15.75 25.375H12.25V9.625H15.75V25.375ZM24.5 24.5C24.5 24.9813 24.1063 25.375 23.625 25.375H17.5V16.625H24.5V24.5ZM26.25 14.875H17.5V9.625H25.375C25.8563 9.625 26.25 10.0188 26.25 10.5V14.875Z"
        fill="#A8C492"
      />
    </Svg>
  );
};

export const SoonGift = () => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M25.375 7.875H23.2258C23.7453 7.14219 24.0625 6.23984 24.0625 5.25C24.0625 2.83828 22.2359 0.875 19.9883 0.875C17.675 0.875 16.3352 2.26406 14 6.11406C11.6648 2.26406 10.325 0.875 8.01172 0.875C5.76406 0.875 3.9375 2.83828 3.9375 5.25C3.9375 6.23984 4.25469 7.14219 4.77422 7.875H2.625C1.17578 7.875 0 9.05078 0 10.5V15.75C0 16.2312 0.39375 16.625 0.875 16.625H1.75V24.5C1.75 25.9492 2.92578 27.125 4.375 27.125H23.625C25.0742 27.125 26.25 25.9492 26.25 24.5V16.625H27.125C27.6063 16.625 28 16.2312 28 15.75V10.5C28 9.05078 26.8242 7.875 25.375 7.875ZM15.1047 7.67812C17.8117 3.12266 18.7141 2.625 19.9883 2.625C21.268 2.625 22.3125 3.80078 22.3125 5.25C22.3125 6.69922 21.268 7.875 19.9883 7.875H14.9844L15.1047 7.67812ZM8.01172 2.625C9.29141 2.625 10.1883 3.12266 12.8953 7.67812L13.0102 7.875H8.00625C6.72656 7.875 5.68203 6.69922 5.68203 5.25C5.6875 3.80078 6.73203 2.625 8.01172 2.625ZM10.5 25.375H4.375C3.89375 25.375 3.5 24.9813 3.5 24.5V16.625H10.5V25.375ZM10.5 14.875H1.75V10.5C1.75 10.0188 2.14375 9.625 2.625 9.625H10.5V14.875ZM15.75 25.375H12.25V9.625H15.75V25.375ZM24.5 24.5C24.5 24.9813 24.1063 25.375 23.625 25.375H17.5V16.625H24.5V24.5ZM26.25 14.875H17.5V9.625H25.375C25.8563 9.625 26.25 10.0188 26.25 10.5V14.875Z"
        fill="#1B4965"
      />
    </Svg>
  );
};

export const GeneralBadge = () => {
  return (
    <Svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M12.0001 6.06536L7.46302 0.891602H0.333328L9.40749 11.8858L16.8749 8.81392L12.0001 6.06536Z"
        fill="#C9DCC5"
      />
      <Path
        d="M16.5372 0.891113L12.0002 6.06486L15.4937 10.7937L16.289 9.8307L23.6669 0.891113H16.5372Z"
        fill="#A8C492"
      />
      <Path
        d="M15.4096 11.2553C15.4614 11.115 15.4945 10.9656 15.4945 10.8071C15.4945 10.0931 14.9137 9.51367 14.1982 9.51367H9.87691C9.1607 9.51367 8.5806 10.0931 8.5806 10.8071C8.5806 10.9656 8.61301 11.115 8.66551 11.2553C6.55382 12.4362 5.12399 14.6874 5.12399 17.2743C5.12399 21.0841 8.21893 24.1729 12.0379 24.1729C15.8561 24.1729 18.9517 21.0841 18.9517 17.2743C18.9511 14.6874 17.5219 12.4362 15.4096 11.2553Z"
        fill="#FFA563"
      />
      <Path
        d="M12.0379 22.4486C14.9017 22.4486 17.2232 20.1322 17.2232 17.2748C17.2232 14.4174 14.9017 12.1011 12.0379 12.1011C9.1742 12.1011 6.85269 14.4174 6.85269 17.2748C6.85269 20.1322 9.1742 22.4486 12.0379 22.4486Z"
        fill="#FFCE63"
      />
      <Path
        d="M14.1249 20.7022C14.0328 20.7022 13.9408 20.6737 13.8617 20.6174L12.0002 19.2858L10.1394 20.6174C9.98057 20.7306 9.76798 20.7306 9.61048 20.6155C9.45297 20.5017 9.38686 20.2993 9.4452 20.1149L10.1394 17.8799L8.29537 16.5832C8.13852 16.4681 8.0737 16.265 8.13333 16.0801C8.19361 15.8957 8.36537 15.7703 8.56047 15.769L10.8446 15.7658L11.5718 13.5863C11.6334 13.402 11.8058 13.2778 12.0009 13.2778C12.1953 13.2778 12.3684 13.402 12.4299 13.5863L13.1449 15.7658L15.4406 15.769C15.6357 15.7703 15.8081 15.8957 15.8678 16.0801C15.928 16.265 15.8626 16.4674 15.7057 16.5832L13.8611 17.8799L14.5552 20.1149C14.6149 20.2999 14.5475 20.5017 14.3906 20.6155C14.3109 20.6737 14.2176 20.7022 14.1249 20.7022Z"
        fill="#FFA563"
      />
    </Svg>
  );
};

export const SmallArrow = () => {
  return (
    <Svg
      width="16"
      height="8"
      viewBox="0 0 16 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M3.99 5.00041L15 5.00041C15.55 5.00041 16 4.55041 16 4.00041C16 3.45041 15.55 3.00041 15 3.00041L3.99 3.00041L3.99 1.21041C3.99 0.76041 3.45 0.540409 3.14 0.860409L0.360001 3.65041C0.170001 3.85041 0.170001 4.16041 0.360001 4.36041L3.14 7.15041C3.45 7.47041 3.99 7.24041 3.99 6.80041L3.99 5.00041Z"
        fill="#1B4965"
      />
    </Svg>
  );
};

export const Star = ({ width, height, color }) => {
  return (
    <Svg
      width={width || "21"}
      height={height || "21"}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M19.8282 6.69972L14.1211 5.86769L11.5703 0.695808C11.1133 -0.226068 9.78909 -0.237786 9.32815 0.695808L6.77737 5.86769L1.07033 6.69972C0.0468936 6.84816 -0.363263 8.10988 0.378925 8.83253L4.50783 12.856L3.53127 18.5396C3.35549 19.5669 4.43752 20.3364 5.34377 19.856L10.4492 17.1724L15.5547 19.856C16.461 20.3325 17.543 19.5669 17.3672 18.5396L16.3907 12.856L20.5196 8.83253C21.2618 8.10988 20.8516 6.84816 19.8282 6.69972ZM15.0508 12.4185L16.1367 18.7466L10.4492 15.7622L4.76565 18.7505L5.85158 12.4224L1.25002 7.9341L7.60549 7.01222L10.4492 1.2505L13.293 7.01222L19.6485 7.9341L15.0508 12.4185Z"
        fill={color || "#1B4965"}
      />
    </Svg>
  );
};

export const Community = () => {
  return (
    <Svg
      width="25"
      height="18"
      viewBox="0 0 25 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M21.25 7.5C22.9766 7.5 24.375 6.10156 24.375 4.375C24.375 2.64844 22.9766 1.25 21.25 1.25C19.5234 1.25 18.125 2.64844 18.125 4.375C18.125 6.10156 19.5234 7.5 21.25 7.5ZM21.25 2.5C22.2852 2.5 23.125 3.33984 23.125 4.375C23.125 5.41016 22.2852 6.25 21.25 6.25C20.2148 6.25 19.375 5.41016 19.375 4.375C19.375 3.33984 20.2148 2.5 21.25 2.5ZM12.5 8.75C14.918 8.75 16.875 6.79297 16.875 4.375C16.875 1.95703 14.918 0 12.5 0C10.082 0 8.125 1.95703 8.125 4.375C8.125 6.79297 10.082 8.75 12.5 8.75ZM12.5 1.25C14.2227 1.25 15.625 2.65234 15.625 4.375C15.625 6.09766 14.2227 7.5 12.5 7.5C10.7773 7.5 9.375 6.09766 9.375 4.375C9.375 2.65234 10.7773 1.25 12.5 1.25ZM22.0312 8.75H20.4688C19.875 8.75 19.3242 8.9375 18.8633 9.25391C19.2305 9.50391 19.5625 9.79688 19.8555 10.1289C20.0469 10.0469 20.2539 10 20.4688 10H22.0312C22.9766 10 23.75 10.8398 23.75 11.875C23.75 12.2188 24.0312 12.5 24.375 12.5C24.7188 12.5 25 12.2188 25 11.875C25 10.1523 23.668 8.75 22.0312 8.75ZM3.75 7.5C5.47656 7.5 6.875 6.10156 6.875 4.375C6.875 2.64844 5.47656 1.25 3.75 1.25C2.02344 1.25 0.625 2.64844 0.625 4.375C0.625 6.10156 2.02344 7.5 3.75 7.5ZM3.75 2.5C4.78516 2.5 5.625 3.33984 5.625 4.375C5.625 5.41016 4.78516 6.25 3.75 6.25C2.71484 6.25 1.875 5.41016 1.875 4.375C1.875 3.33984 2.71484 2.5 3.75 2.5ZM15.6289 9.53125C14.3242 9.53125 14 10 12.5 10C11 10 10.6758 9.53125 9.37109 9.53125C7.95312 9.53125 6.57422 10.1641 5.76562 11.3633C5.28125 12.082 5 12.9453 5 13.875V15.625C5 16.6602 5.83984 17.5 6.875 17.5H18.125C19.1602 17.5 20 16.6602 20 15.625V13.875C20 12.9453 19.7188 12.082 19.2344 11.3633C18.4258 10.1641 17.0469 9.53125 15.6289 9.53125ZM18.75 15.625C18.75 15.9688 18.4688 16.25 18.125 16.25H6.875C6.53125 16.25 6.25 15.9688 6.25 15.625V13.875C6.25 13.2266 6.44141 12.5977 6.80078 12.0625C7.33984 11.2617 8.30078 10.7812 9.36719 10.7812C10.4375 10.7812 10.8203 11.25 12.5 11.25C14.1797 11.25 14.5625 10.7812 15.6289 10.7812C16.6953 10.7812 17.6562 11.2617 18.1953 12.0625C18.5547 12.5977 18.7461 13.2266 18.7461 13.875V15.625H18.75ZM6.13672 9.25391C5.67188 8.9375 5.12109 8.75 4.53125 8.75H2.96875C1.33203 8.75 0 10.1523 0 11.875C0 12.2188 0.28125 12.5 0.625 12.5C0.96875 12.5 1.25 12.2188 1.25 11.875C1.25 10.8398 2.02344 10 2.96875 10H4.53125C4.74609 10 4.95312 10.0469 5.14453 10.1289C5.4375 9.79688 5.77344 9.50391 6.13672 9.25391Z"
        fill="#1B4965"
      />
    </Svg>
  );
};
export const SpeechBubble = ({ width, height, color }) => {
  return (
    <Svg
      width={width || "21"}
      height={height || "18"}
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M5.00259 7.1875C4.48306 7.1875 4.06509 7.60547 4.06509 8.125C4.06509 8.64453 4.48306 9.0625 5.00259 9.0625C5.52213 9.0625 5.94009 8.64453 5.94009 8.125C5.94009 7.60547 5.52213 7.1875 5.00259 7.1875ZM10.0026 7.1875C9.48306 7.1875 9.06509 7.60547 9.06509 8.125C9.06509 8.64453 9.48306 9.0625 10.0026 9.0625C10.5221 9.0625 10.9401 8.64453 10.9401 8.125C10.9401 7.60547 10.5221 7.1875 10.0026 7.1875ZM15.0026 7.1875C14.4831 7.1875 14.0651 7.60547 14.0651 8.125C14.0651 8.64453 14.4831 9.0625 15.0026 9.0625C15.5221 9.0625 15.9401 8.64453 15.9401 8.125C15.9401 7.60547 15.5221 7.1875 15.0026 7.1875ZM10.0026 0C4.47916 0 0.00259251 3.63672 0.00259251 8.125C0.00259251 9.98438 0.779937 11.6875 2.069 13.0586C1.48697 14.5977 0.27603 15.9023 0.256499 15.918C-0.00131374 16.1914 -0.0716263 16.5898 0.0768113 16.9336C0.225249 17.2773 0.565093 17.5 0.940093 17.5C3.34244 17.5 5.23697 16.4961 6.37369 15.6914C7.50259 16.0469 8.72134 16.25 10.0026 16.25C15.526 16.25 20.0026 12.6133 20.0026 8.125C20.0026 3.63672 15.526 0 10.0026 0ZM10.0026 15C8.89713 15 7.80338 14.832 6.75259 14.5L6.15884 14.3125L5.65103 14.6719C4.75259 15.3086 3.36587 16.0508 1.64322 16.2188C2.11197 15.6289 2.80728 14.6406 3.23697 13.5L3.51431 12.7695L2.97916 12.1992C1.85025 11.0039 1.25259 9.59375 1.25259 8.125C1.25259 4.33594 5.17838 1.25 10.0026 1.25C14.8268 1.25 18.7526 4.33594 18.7526 8.125C18.7526 11.9141 14.8268 15 10.0026 15Z"
        fill={color || "#1B4965"}
      />
    </Svg>
  );
};
export const Book = () => {
  return (
    <Svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M13.3102 5.98213H7.02901C6.78224 5.98213 6.58035 5.78024 6.58035 5.53347V5.23437C6.58035 4.9876 6.78224 4.78571 7.02901 4.78571H13.3102C13.557 4.78571 13.7589 4.9876 13.7589 5.23437V5.53347C13.7589 5.78024 13.557 5.98213 13.3102 5.98213ZM13.7589 7.92632V7.62722C13.7589 7.38046 13.557 7.17856 13.3102 7.17856H7.02901C6.78224 7.17856 6.58035 7.38046 6.58035 7.62722V7.92632C6.58035 8.17309 6.78224 8.37498 7.02901 8.37498H13.3102C13.557 8.37498 13.7589 8.17309 13.7589 7.92632ZM16.1779 17.9464H16.3013C16.5481 17.9464 16.75 18.1483 16.75 18.3951V18.6942C16.75 18.9409 16.5481 19.1428 16.3013 19.1428H2.99107C1.3385 19.1428 0 17.8043 0 16.1518V2.99107C0 1.3385 1.3385 0 2.99107 0H15.8526C16.3499 0 16.75 0.400055 16.75 0.89732V14.6562C16.75 15.0301 16.5182 15.3516 16.1929 15.4862C16.0583 16.0882 16.0284 17.1912 16.1779 17.9464ZM4.78571 14.3571H15.5535V1.19643H4.78571V14.3571ZM1.19643 14.9553C1.69743 14.5814 2.31808 14.3571 2.99107 14.3571H3.58928V1.19643H2.99107C2.00028 1.19643 1.19643 2.00028 1.19643 2.99107V14.9553ZM15.1161 17.9464C15.0002 17.1837 15.0077 16.2564 15.1161 15.5535H2.99107C0.598213 15.5535 0.598213 17.9464 2.99107 17.9464H15.1161Z"
        fill="#1B4965"
      />
    </Svg>
  );
};
export const Person = () => {
  return (
    <Svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M12.25 11.25C11.1289 11.25 10.5898 11.875 8.75 11.875C6.91016 11.875 6.375 11.25 5.25 11.25C2.35156 11.25 0 13.6016 0 16.5V18.125C0 19.1602 0.839844 20 1.875 20H15.625C16.6602 20 17.5 19.1602 17.5 18.125V16.5C17.5 13.6016 15.1484 11.25 12.25 11.25ZM16.25 18.125C16.25 18.4688 15.9688 18.75 15.625 18.75H1.875C1.53125 18.75 1.25 18.4688 1.25 18.125V16.5C1.25 14.293 3.04297 12.5 5.25 12.5C6.01562 12.5 6.77734 13.125 8.75 13.125C10.7188 13.125 11.4844 12.5 12.25 12.5C14.457 12.5 16.25 14.293 16.25 16.5V18.125ZM8.75 10C11.5117 10 13.75 7.76172 13.75 5C13.75 2.23828 11.5117 0 8.75 0C5.98828 0 3.75 2.23828 3.75 5C3.75 7.76172 5.98828 10 8.75 10ZM8.75 1.25C10.8164 1.25 12.5 2.93359 12.5 5C12.5 7.06641 10.8164 8.75 8.75 8.75C6.68359 8.75 5 7.06641 5 5C5 2.93359 6.68359 1.25 8.75 1.25Z"
        fill="#1B4965"
      />
    </Svg>
  );
};
export const Hand = ({ width, height, color }) => {
  return (
    <Svg
      width={width || "16"}
      height={height || "19"}
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M14.0031 4.70386C13.6959 4.70386 13.4065 4.77174 13.1457 4.89677V3.84651C13.1457 2.74267 12.2491 1.84602 11.1452 1.84602C10.7987 1.84602 10.4736 1.93533 10.1914 2.08894C9.93064 1.28517 9.17688 0.702881 8.28738 0.702881C7.39788 0.702881 6.64412 1.28517 6.38334 2.08894C6.10113 1.93533 5.77605 1.84602 5.42954 1.84602C4.32569 1.84602 3.42905 2.74267 3.42905 3.84651V9.30499C3.01823 8.88346 1.9251 8.31546 0.853413 9.06565C-0.0503806 9.69795 -0.271864 10.9483 0.360435 11.852L4.42215 17.9714C4.84725 18.6108 5.55814 18.9931 6.32619 18.9931H12.7778C13.8638 18.9931 14.8068 18.2215 15.0212 17.1569L15.7571 13.4703C15.9178 12.6594 16 11.8306 16 11.0054V6.70435C16.0036 5.60051 15.1069 4.70386 14.0031 4.70386V4.70386ZM14.8604 11.0018C14.8604 11.7556 14.7854 12.5058 14.6389 13.2452L13.903 16.9319C13.7959 17.4677 13.3279 17.8499 12.7813 17.8499H6.32976C5.94752 17.8499 5.59029 17.657 5.37595 17.3391L1.29638 11.1983C1.02488 10.8089 1.11776 10.2767 1.50714 10.0052C2.07157 9.60864 2.57884 10.0409 2.70029 10.2159L4.05063 12.1593C4.21138 12.3879 4.57218 12.2772 4.57218 11.9949V3.84651C4.57218 3.37139 4.95442 2.98916 5.42954 2.98916C5.90465 2.98916 6.28689 3.37139 6.28689 3.84651V9.5622C6.28689 9.71938 6.41549 9.84798 6.57267 9.84798H7.14424C7.30142 9.84798 7.43003 9.71938 7.43003 9.5622V2.70337C7.43003 2.22826 7.81226 1.84602 8.28738 1.84602C8.7625 1.84602 9.14473 2.22826 9.14473 2.70337V9.5622C9.14473 9.71938 9.27334 9.84798 9.43052 9.84798H10.0021C10.1593 9.84798 10.2879 9.71938 10.2879 9.5622V3.84651C10.2879 3.37139 10.6701 2.98916 11.1452 2.98916C11.6203 2.98916 12.0026 3.37139 12.0026 3.84651V9.5622C12.0026 9.71938 12.1312 9.84798 12.2884 9.84798H12.8599C13.0171 9.84798 13.1457 9.71938 13.1457 9.5622V6.70435C13.1457 6.22924 13.528 5.847 14.0031 5.847C14.4782 5.847 14.8604 6.22924 14.8604 6.70435V11.0018ZM11.9061 11.3841C11.6882 11.209 11.3131 10.9911 10.8237 10.9911C10.3557 10.9911 9.7806 11.1912 9.14473 11.8163C8.50886 11.1912 7.93372 10.9911 7.46575 10.9911C6.97634 10.9911 6.59768 11.209 6.38334 11.3841C5.54028 12.0664 5.49741 13.2953 6.25117 14.0347L8.84466 16.5818C9.01256 16.7461 9.28405 16.7461 9.45195 16.5818L12.0454 14.0347C12.7921 13.2953 12.7492 12.0664 11.9061 11.3841V11.3841ZM11.2381 13.2202L9.14473 15.2779L7.05136 13.2202C6.62269 12.7987 6.97634 12.1343 7.46575 12.1343C7.70509 12.1343 8.01946 12.3129 8.34454 12.6308L9.14473 13.4203L9.94493 12.6308C10.27 12.3093 10.5844 12.1343 10.8237 12.1343C11.3131 12.1343 11.6668 12.7987 11.2381 13.2202Z"
        fill={color || "#1B4965"}
      />
    </Svg>
  );
};

export const FrLogo = () => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      id="flag-icons-fr"
      viewBox="0 0 640 480"
    >
      <G fillRule="evenodd" strokeWidth="1pt">
        <Path fill="#fff" d="M0 0h640v480H0z" />
        <Path fill="#002654" d="M0 0h213.3v480H0z" />
        <Path fill="#ce1126" d="M426.7 0H640v480H426.7z" />
      </G>
    </Svg>
  );
};

export const LanguageIcon = ({ color }) => {
  return (
    <Svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      strokeWidth="1"
      strokeLinecap="square"
      strokeLinejoin="miter"
      fill="none"
      color={color}
    >
      <Circle cx="12" cy="12" r="10" />
      <Path
        strokeLinecap="round"
        d="M12,22 C14.6666667,19.5757576 16,16.2424242 16,12 C16,7.75757576 14.6666667,4.42424242 12,2 C9.33333333,4.42424242 8,7.75757576 8,12 C8,16.2424242 9.33333333,19.5757576 12,22 Z"
      />
      <Path strokeLinecap="round" d="M2.5 9L21.5 9M2.5 15L21.5 15" />
    </Svg>
  );
};

export const EnLogo = () => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      id="flag-icons-us"
      viewBox="0 0 640 480"
    >
      <G fillRule="evenodd">
        <G strokeWidth="1pt">
          <Path
            fill="#bd3d44"
            d="M0 0h912v37H0zm0 73.9h912v37H0zm0 73.8h912v37H0zm0 73.8h912v37H0zm0 74h912v36.8H0zm0 73.7h912v37H0zM0 443h912V480H0z"
          />
          <Path
            fill="#fff"
            d="M0 37h912v36.9H0zm0 73.8h912v36.9H0zm0 73.8h912v37H0zm0 73.9h912v37H0zm0 73.8h912v37H0zm0 73.8h912v37H0z"
          />
        </G>
        <Path fill="#192f5d" d="M0 0h364.8v258.5H0z" />
        <Path
          fill="#fff"
          d="m30.4 11 3.4 10.3h10.6l-8.6 6.3 3.3 10.3-8.7-6.4-8.6 6.3L25 27.6l-8.7-6.3h10.9zm60.8 0 3.3 10.3h10.8l-8.7 6.3 3.2 10.3-8.6-6.4-8.7 6.3 3.3-10.2-8.6-6.3h10.6zm60.8 0 3.3 10.3H166l-8.6 6.3 3.3 10.3-8.7-6.4-8.7 6.3 3.3-10.2-8.7-6.3h10.8zm60.8 0 3.3 10.3h10.8l-8.7 6.3 3.3 10.3-8.7-6.4-8.7 6.3 3.4-10.2-8.8-6.3h10.7zm60.8 0 3.3 10.3h10.7l-8.6 6.3 3.3 10.3-8.7-6.4-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm60.8 0 3.3 10.3h10.8l-8.8 6.3 3.4 10.3-8.7-6.4-8.7 6.3 3.4-10.2-8.8-6.3h10.8zM60.8 37l3.3 10.2H75l-8.7 6.2 3.2 10.3-8.5-6.3-8.7 6.3 3.1-10.3-8.4-6.2h10.7zm60.8 0 3.4 10.2h10.7l-8.8 6.2 3.4 10.3-8.7-6.3-8.7 6.3 3.3-10.3-8.7-6.2h10.8zm60.8 0 3.3 10.2h10.8l-8.7 6.2 3.3 10.3-8.7-6.3-8.7 6.3 3.3-10.3-8.6-6.2H179zm60.8 0 3.4 10.2h10.7l-8.8 6.2 3.4 10.3-8.7-6.3-8.6 6.3 3.2-10.3-8.7-6.2H240zm60.8 0 3.3 10.2h10.8l-8.7 6.2 3.3 10.3-8.7-6.3-8.7 6.3 3.3-10.3-8.6-6.2h10.7zM30.4 62.6l3.4 10.4h10.6l-8.6 6.3 3.3 10.2-8.7-6.3-8.6 6.3L25 79.3 16.3 73h10.9zm60.8 0L94.5 73h10.8l-8.7 6.3 3.2 10.2-8.6-6.3-8.7 6.3 3.3-10.3-8.6-6.3h10.6zm60.8 0 3.3 10.3H166l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.3-8.7-6.3h10.8zm60.8 0 3.3 10.3h10.8l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.4-10.3-8.8-6.3h10.7zm60.8 0 3.3 10.3h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.3-8.6-6.3h10.7zm60.8 0 3.3 10.3h10.8l-8.8 6.3 3.4 10.2-8.7-6.3-8.7 6.3 3.4-10.3-8.8-6.3h10.8zM60.8 88.6l3.3 10.2H75l-8.7 6.3 3.3 10.3-8.7-6.4-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm60.8 0 3.4 10.2h10.7l-8.8 6.3 3.4 10.3-8.7-6.4-8.7 6.3 3.3-10.2-8.7-6.3h10.8zm60.8 0 3.3 10.2h10.8l-8.7 6.3 3.3 10.3-8.7-6.4-8.7 6.3 3.3-10.2-8.6-6.3H179zm60.8 0 3.4 10.2h10.7l-8.7 6.3 3.3 10.3-8.7-6.4-8.6 6.3 3.2-10.2-8.7-6.3H240zm60.8 0 3.3 10.2h10.8l-8.7 6.3 3.3 10.3-8.7-6.4-8.7 6.3 3.3-10.2-8.6-6.3h10.7zM30.4 114.5l3.4 10.2h10.6l-8.6 6.3 3.3 10.3-8.7-6.4-8.6 6.3L25 131l-8.7-6.3h10.9zm60.8 0 3.3 10.2h10.8l-8.7 6.3 3.2 10.2-8.6-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.6zm60.8 0 3.3 10.2H166l-8.6 6.3 3.3 10.3-8.7-6.4-8.7 6.3 3.3-10.2-8.7-6.3h10.8zm60.8 0 3.3 10.2h10.8l-8.7 6.3 3.3 10.3-8.7-6.4-8.7 6.3 3.4-10.2-8.8-6.3h10.7zm60.8 0 3.3 10.2h10.7L279 131l3.3 10.3-8.7-6.4-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm60.8 0 3.3 10.2h10.8l-8.8 6.3 3.4 10.3-8.7-6.4-8.7 6.3L329 131l-8.8-6.3h10.8zM60.8 140.3l3.3 10.3H75l-8.7 6.2 3.3 10.3-8.7-6.4-8.7 6.4 3.3-10.3-8.6-6.3h10.7zm60.8 0 3.4 10.3h10.7l-8.8 6.2 3.4 10.3-8.7-6.4-8.7 6.4 3.3-10.3-8.7-6.3h10.8zm60.8 0 3.3 10.3h10.8l-8.7 6.2 3.3 10.3-8.7-6.4-8.7 6.4 3.3-10.3-8.6-6.3H179zm60.8 0 3.4 10.3h10.7l-8.7 6.2 3.3 10.3-8.7-6.4-8.6 6.4 3.2-10.3-8.7-6.3H240zm60.8 0 3.3 10.3h10.8l-8.7 6.2 3.3 10.3-8.7-6.4-8.7 6.4 3.3-10.3-8.6-6.3h10.7zM30.4 166.1l3.4 10.3h10.6l-8.6 6.3 3.3 10.1-8.7-6.2-8.6 6.2 3.2-10.2-8.7-6.3h10.9zm60.8 0 3.3 10.3h10.8l-8.7 6.3 3.3 10.1-8.7-6.2-8.7 6.2 3.4-10.2-8.7-6.3h10.6zm60.8 0 3.3 10.3H166l-8.6 6.3 3.3 10.1-8.7-6.2-8.7 6.2 3.3-10.2-8.7-6.3h10.8zm60.8 0 3.3 10.3h10.8l-8.7 6.3 3.3 10.1-8.7-6.2-8.7 6.2 3.4-10.2-8.8-6.3h10.7zm60.8 0 3.3 10.3h10.7l-8.6 6.3 3.3 10.1-8.7-6.2-8.7 6.2 3.3-10.2-8.6-6.3h10.7zm60.8 0 3.3 10.3h10.8l-8.8 6.3 3.4 10.1-8.7-6.2-8.7 6.2 3.4-10.2-8.8-6.3h10.8zM60.8 192l3.3 10.2H75l-8.7 6.3 3.3 10.3-8.7-6.4-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm60.8 0 3.4 10.2h10.7l-8.8 6.3 3.4 10.3-8.7-6.4-8.7 6.3 3.3-10.2-8.7-6.3h10.8zm60.8 0 3.3 10.2h10.8l-8.7 6.3 3.3 10.3-8.7-6.4-8.7 6.3 3.3-10.2-8.6-6.3H179zm60.8 0 3.4 10.2h10.7l-8.7 6.3 3.3 10.3-8.7-6.4-8.6 6.3 3.2-10.2-8.7-6.3H240zm60.8 0 3.3 10.2h10.8l-8.7 6.3 3.3 10.3-8.7-6.4-8.7 6.3 3.3-10.2-8.6-6.3h10.7zM30.4 217.9l3.4 10.2h10.6l-8.6 6.3 3.3 10.2-8.7-6.3-8.6 6.3 3.2-10.3-8.7-6.3h10.9zm60.8 0 3.3 10.2h10.8l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.4-10.3-8.7-6.3h10.6zm60.8 0 3.3 10.2H166l-8.4 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.3-8.7-6.3h10.8zm60.8 0 3.3 10.2h10.8l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.4-10.3-8.8-6.3h10.7zm60.8 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.3-8.6-6.3h10.7zm60.8 0 3.3 10.2h10.8l-8.8 6.3 3.4 10.2-8.7-6.3-8.7 6.3 3.4-10.3-8.8-6.3h10.8z"
        />
      </G>
    </Svg>
  );
};

export const GoogleLogo = () => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 186.69 190.5"
    >
      <G transform="translate(1184.583 765.171)">
        <Path
          d="M-1089.333-687.239v36.888h51.262c-2.251 11.863-9.006 21.908-19.137 28.662l30.913 23.986c18.011-16.625 28.402-41.044 28.402-70.052 0-6.754-.606-13.249-1.732-19.483z"
          fill="#4285f4"
        />
        <Path
          d="M-1142.714-651.791l-6.972 5.337-24.679 19.223h0c15.673 31.086 47.796 52.561 85.03 52.561 25.717 0 47.278-8.486 63.038-23.033l-30.913-23.986c-8.486 5.715-19.31 9.179-32.125 9.179-24.765 0-45.806-16.712-53.34-39.226z"
          fill="#34a853"
        />
        <Path
          d="M-1174.365-712.61c-6.494 12.815-10.217 27.276-10.217 42.689s3.723 29.874 10.217 42.689c0 .086 31.693-24.592 31.693-24.592-1.905-5.715-3.031-11.776-3.031-18.098s1.126-12.383 3.031-18.098z"
          fill="#fbbc05"
        />
        <Path
          d="M-1089.333-727.244c14.028 0 26.497 4.849 36.455 14.201l27.276-27.276c-16.539-15.413-38.013-24.852-63.731-24.852-37.234 0-69.359 21.388-85.032 52.561l31.692 24.592c7.533-22.514 28.575-39.226 53.34-39.226z"
          fill="#ea4335"
        />
      </G>
    </Svg>
  );
};

export const MessageOfMonthIcon = ({ color }) => {
  return (
    <Svg id="Calque_1" width="100%" height="100%" viewBox="0 0 44.3891 44.3891">
      <Path
        d="M41.0686,50.0481h.0225m8.9529,0h.0224m8.953,0h.0224m11.2055,0A20.1944,20.1944,0,0,1,50.0527,70.2426H29.86s3.4986-8.4007,2.0984-11.2174a20.1965,20.1965,0,1,1,38.2891-8.9771Z"
        transform="translate(-27.8582 -27.8535)"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </Svg>
  );
};

export const TutoIcon = ({ color }) => {
  return (
    <Svg
      id="Calque_1"
      width="100%"
      height="100%"
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48.77 44.293"
    >
      <Path
        d="M63.431,29.8535H36.569a8.9539,8.9539,0,0,0-8.954,8.954v22.385a8.954,8.954,0,0,0,8.954,8.954H63.431a8.9541,8.9541,0,0,0,8.954-8.954V38.8075A8.954,8.954,0,0,0,63.431,29.8535Z"
        transform="translate(-25.615 -27.8535)"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <Path
        d="M46.15,41.1354c-2.44.873-2.8653,5.5514-2.8653,8.9539s.4254,7.9691,2.8653,8.954,12.8042-5.1261,12.8042-8.954S48.7464,40.1952,46.15,41.1354Z"
        transform="translate(-25.615 -27.8535)"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </Svg>
  );
};

export const BilanIcon = ({ color }) => {
  return (
    <Svg
      id="Calque_1"
      width="100%"
      height="100%"
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 58.0191 58.0191"
    >
      <Path
        d="M23.2723,78.51h7.637a1.7813,1.7813,0,0,0,1.7818-1.7819V63.6953a1.7813,1.7813,0,0,0-1.7818-1.7819h-7.637A1.7814,1.7814,0,0,0,21.49,63.6953V76.7277A1.7826,1.7826,0,0,0,23.2723,78.51Zm1.7818-13.0343h4.0733v9.4688H25.0541Z"
        transform="translate(-20.9904 -20.9904)"
        fill={color}
      />
      <Path
        d="M46.1815,78.51a1.7813,1.7813,0,0,0,1.7818-1.7819V39.95a1.7813,1.7813,0,0,0-1.7818-1.7819h-7.637A1.7813,1.7813,0,0,0,36.7627,39.95V76.7277A1.7813,1.7813,0,0,0,38.5445,78.51ZM40.3264,41.7322H44.4V74.9459H40.3264Z"
        transform="translate(-20.9904 -20.9904)"
        fill={color}
      />
      <Path
        d="M61.4537,78.51a1.7814,1.7814,0,0,0,1.7819-1.7819V52.1329a1.7814,1.7814,0,0,0-1.7819-1.7819H53.8185a1.7813,1.7813,0,0,0-1.7818,1.7819V76.7277A1.7813,1.7813,0,0,0,53.8185,78.51ZM55.6,53.9147h4.0733V74.9459H55.6Z"
        transform="translate(-20.9904 -20.9904)"
        fill={color}
      />
      <Path
        d="M67.3089,23.2723V76.7277A1.7813,1.7813,0,0,0,69.0907,78.51h7.637A1.7814,1.7814,0,0,0,78.51,76.7277V23.2723A1.7814,1.7814,0,0,0,76.7277,21.49h-7.637A1.7813,1.7813,0,0,0,67.3089,23.2723Zm3.5637,1.7818h4.0733V74.9459H70.8726Z"
        transform="translate(-20.9904 -20.9904)"
        fill={color}
      />
    </Svg>
  );
};

export const NewIcon = ({ color }) => {
  return (
    <Svg
      id="Calque_1"
      width="100%"
      height="100%"
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64.5159 37.6242"
    >
      <G id="icons_Q2" data-name="icons Q2">
        <Path
          d="M78.8709,31.6879H21.1291c-1.5945,0-2.8871,1.64-2.8871,3.6624V64.65c0,2.0227,1.2926,3.6624,2.8871,3.6624H78.8709c1.5945,0,2.8871-1.64,2.8871-3.6624V35.35C81.758,33.3276,80.4654,31.6879,78.8709,31.6879ZM40.3283,59.1561H36.7194L32.3888,50l-1.0105-2.3806h0V59.1561H27.9138V40.8439h3.6088L35.8533,50l.8661,2.3806h.1444s-.1444-2.1975-.1444-2.93V40.8439h3.6089Zm13.1362,0H42.3492V40.8439H53.32v3.6625H45.9581v3.2961H52.31V51.465H45.9581v3.8455h7.5064Zm15.7346,0H65.59l-1.4436-8.79c-.2887-1.4649-.5774-3.4793-.5774-3.4793h0s-.2887,2.0144-.4331,3.4793l-1.5879,8.79H58.0838L54.0419,40.8439h3.6089l1.4435,7.6911a45.6693,45.6693,0,0,1,.7218,4.5781h0l.7218-4.3949,1.4435-7.8743h3.32l1.2992,7.8743.7217,4.3949h0l.7218-4.5781,1.4435-7.6911h3.6089Z"
          transform="translate(-17.742 -31.1879)"
          fill={color}
        />
      </G>
    </Svg>
  );
};
